// extracted by mini-css-extract-plugin
export default {"root":"styles_root__cx1Gi","icon":"styles_icon__KzQVJ","title":"styles_title__YGmGc"};